import { Injectable } from '@angular/core';
import { DictionaryType } from '../../dictionary-type.enum';
import { DictionaryMode } from '../../dictionary-mode.enum';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigurationService } from '../../../configuration/app-configuration.service';
import { map } from 'rxjs/operators';
import { toCamel } from '../common/json-helper';
import { DictionaryServiceBase } from '../common/dictionary-service-base';
import { DictionaryDropdownItem } from '../../dictionary-dropdown-item.interface';
import { IFertilizerTypeDictionaryModel } from './fertilizer-type-dictionary.model';
import { ApiListResponse } from '../../../webapi';

@Injectable()
export class FertilizerTypeDictionaryService extends DictionaryServiceBase<IFertilizerTypeDictionaryModel[]> {
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigurationService
  ) {
    super();
  }

  type: DictionaryType = DictionaryType.FertilizerType;
  mode: DictionaryMode = DictionaryMode.Static;

  loadData(): Observable<IFertilizerTypeDictionaryModel[]> {
    const url = `${this.config.configuration.api_url}/api/v1/fertilizers?page=1&pageSize=999999&fields=name`;

    return this.httpClient
      .get<ApiListResponse<IFertilizerTypeDictionaryModel>>(url)
      .pipe(map(result => result.items))
      .pipe(map(result => result.map(x => toCamel(x) as IFertilizerTypeDictionaryModel)))
      .pipe(
        map(result =>
          result.map(x => {
            x.dictionaryType = DictionaryType[DictionaryType.FertilizerType];
            x.codeName = x.name;
            return x;
          })
        )
      );
  }

  mapItem(item: IFertilizerTypeDictionaryModel): DictionaryDropdownItem {
    return {
      label: item.name,
      value: JSON.stringify({ rowKey: item.rowKey, name: item.name })
    };
  }
}
